import PropTypes from 'prop-types'
import React from 'react'
import { LazyLoadImage, Link } from 'Blocks'
import { cutTitleToLimit } from 'Utils'
import get from 'lodash/get'

const FeatureBlock = ({
  article,
  buttonUrl = '',
  title = '',
  target = '',
  className = '',
  buttonLabel = '',
  shouldRender = true,
  isPanelLink = false,
  alt = '',
  style = {}
}) => {
  const displayCut = cutTitleToLimit(title.short, 50)
  const titleCut = title.long.substring(0, 60)
  const image = get(article, 'image.main', '')

  return shouldRender ? (
    isPanelLink ? (
      <Link to={buttonUrl} {...{ className, style }}>
        <LazyLoadImage {...{ alt }} image={image} width="600" crop="limit" />
        <div className="content">
          <h1 className="title">{displayCut}</h1>
          {titleCut && <p className="intro">{`${titleCut}...`}&nbsp;</p>}
          <div className="button">{buttonLabel}</div>
        </div>
      </Link>
    ) : (
      <div {...{ className, style }}>
        <LazyLoadImage {...{ alt }} image={image} width="600" crop="limit" />
        <div className="content">
          <h1 className="title">{displayCut}</h1>
          {titleCut && <p className="intro">{`${titleCut}...`}&nbsp;</p>}
          <Link className="button" target={target} to={buttonUrl}>
            {buttonLabel}
          </Link>
        </div>
      </div>
    )
  ) : null
}

FeatureBlock.displayName = 'FeatureBlock'

FeatureBlock.propTypes = {
  alt: PropTypes.string,
  article: PropTypes.any,
  buttonLabel: PropTypes.string,
  buttonUrl: PropTypes.string,
  className: PropTypes.string,
  isPanelLink: PropTypes.bool,
  shouldRender: PropTypes.bool,
  style: PropTypes.object,
  target: PropTypes.string,
  title: PropTypes.object
}

export default FeatureBlock
